export const PROFESSIONAL_TEMPLATES = [
  {
    id: 'sys-luxhouse-ultra-black',
    name: "Lux House Design - Luxury Black (No-Remote)",
    description: "Exclusive ultra-black design. Zero remote content. Displays perfectly in Thunderbird immediately.",
    subject: "Luxury Architecture & Design - Lux House Design",
    html: `
<div style="background-color: #000000; margin: 0; padding: 0;">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #000000; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; min-height: 100vh;">
        <tr>
            <td align="center" style="padding: 20px 0;">
                <table border="0" cellpadding="0" cellspacing="0" width="600" style="background-color: #0a0a0a; width: 600px; border: 1px solid #1a1a1a;">
                    <tr>
                        <td align="center" style="padding: 60px 40px; background-color: #000000; border-bottom: 1px solid #111111;">
                            <div style="letter-spacing: 8px; font-size: 22px; color: #ffffff; font-weight: 800; text-transform: uppercase; margin-bottom: 5px;">Lux House</div>
                            <div style="letter-spacing: 5px; font-size: 14px; color: #ffffff; font-weight: 300; text-transform: uppercase;">Design</div>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding: 100px 40px; text-align: center; background-color: #080808;">
                            <h1 style="color: #ffffff; font-size: 48px; font-weight: 800; line-height: 1.0; margin: 0 0 25px 0; letter-spacing: -2px; text-transform: uppercase;">Definition of<br>Luxury</h1>
                            <a href="https://luxhousedesign.com" style="background-color: #ffffff; color: #000000; padding: 20px 50px; text-decoration: none; font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 4px; display: inline-block;">Discover Portfolio</a>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>
    `
  },
  {
    id: 'sys-ailinkb-luxury',
    name: "AILinkB - Luxury Intelligence",
    description: "Exclusive Ultra-Black template for AILinkB. Minimalist and high impact.",
    subject: "Your emails look boring and flat?",
    html: `
<div style="background-color: #000000; margin: 0; padding: 0;">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #000000; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; min-height: 100vh;">
        <tr>
            <td align="center" style="padding: 20px 0;">
                
                <table border="0" cellpadding="0" cellspacing="0" width="600" style="background-color: #0a0a0a; width: 600px; border: 1px solid #1a1a1a;">
                    
                    <!-- TEXT LOGO HEADER -->
                    <tr>
                        <td align="center" style="padding: 60px 40px; background-color: #000000; border-bottom: 1px solid #111111;">
                            <div style="letter-spacing: 8px; font-size: 24px; color: #ffffff; font-weight: 800; text-transform: uppercase; margin-bottom: 5px;">AILinkB</div>
                            <div style="letter-spacing: 5px; font-size: 12px; color: #4f46e5; font-weight: 700; text-transform: uppercase;">Intelligence</div>
                        </td>
                    </tr>

                    <!-- HERO SECTION -->
                    <tr>
                        <td style="padding: 100px 40px; text-align: center; background-color: #080808; border-bottom: 1px solid #111111;">
                            <div style="border: 1px solid #333333; display: inline-block; padding: 6px 20px; border-radius: 1px; font-size: 9px; text-transform: uppercase; letter-spacing: 4px; color: #ffffff; margin-bottom: 30px;">Next Gen Communication</div>
                            <h1 style="color: #ffffff; font-size: 42px; font-weight: 800; line-height: 1.1; margin: 0 0 25px 0; letter-spacing: -1px; text-transform: uppercase;">Do You have difficulties to find information in Your Email box?</h1>
                            <table align="center" border="0" cellpadding="0" cellspacing="0" width="80" style="margin-bottom: 35px;">
                                <tr><td height="2" style="background-color: #4f46e5; font-size: 1px; line-height: 1px;">&nbsp;</td></tr>
                            </table>
                            <p style="color: #ffffff; font-size: 16px; line-height: 1.6; margin-bottom: 15px; font-weight: 400; max-width: 450px; margin-left: auto; margin-right: auto;">Do You like to send fancy looking emails or maybe You would like to use advantage of AI in sending email.</p>
                            <p style="color: #777777; font-size: 14px; line-height: 1.6; margin-bottom: 45px; font-weight: 300;">Please contact.</p>
                            <a href="mailto:office@ailinkb.com?subject=Improve%20my%20email%20communication&body=Hello%2C%0A%0ACan%20you%20tell%20me%20how%20to%20improve%20my%20email%20communication%3F" target="_top" style="background-color: #4f46e5; color: #ffffff; padding: 20px 50px; text-decoration: none; border-radius: 4px; font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 4px; display: inline-block; cursor: pointer;">Elevate Your Email</a>
                        </td>
                    </tr>

                    <!-- FOOTER -->
                    <tr>
                        <td style="background-color: #050505; padding: 60px 40px; color: #ffffff; border-top: 1px solid #111111;">
                            <table border="0" cellpadding="0" cellspacing="0" width="100%">
                                <tr>
                                    <td valign="top" style="padding-bottom: 35px;">
                                        <div style="font-size: 16px; font-weight: 800; letter-spacing: 5px; margin-bottom: 12px; text-transform: uppercase;">AILinkB</div>
                                        <div style="font-size: 10px; color: #333333; text-transform: uppercase; letter-spacing: 3px;">The Future of CRM &copy; 2026</div>
                                    </td>
                                    <td align="right" valign="top">
                                        <div style="font-size: 12px; line-height: 2.2; color: #555555; font-weight: 300;">
                                            QR-SYSTEM sp. z o.o.<br>
                                            office@ailinkb.com<br>
                                            www.ailinkb.com
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>
    `
  }
];
